import React from 'react';
import { theme } from 'theme/theme';

import { TrackOpensCheckbox } from 'components/tracking/TrackOpensCheckbox';

import { ActionCheckboxRow } from './ActionCheckboxRow';
import { ButtonRow } from './ButtonRow';
import { ExpectedReplyRow } from './ExpectedReplyRow';
import { ScheduledTimeBanner } from './ScheduledTimeBanner';
import { ReplyComposerFooterProps, useReplyComposerFooter } from './useReplyComposerFooter';

export { getScheduleSuggestions } from './scheduleUtils';

/**
 * Footer for the reply composer: scheduled-time banner, expected-reply selector,
 * keep-in-action and track-opens checkboxes, and cancel/send/schedule buttons.
 */
export const ReplyComposerFooter: React.FC<ReplyComposerFooterProps> = props => {
  const { onClose, onClearSchedule, scheduledSendAt, sending, checkingTone } = props;
  const hook = useReplyComposerFooter(props);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: theme.spacing.md, marginTop: theme.spacing.md }}>
      {scheduledSendAt && <ScheduledTimeBanner scheduledSendAt={scheduledSendAt} onClearSchedule={onClearSchedule} />}

      <ExpectedReplyRow
        followUpDuration={hook.followUpDuration}
        disabled={sending || checkingTone}
        tooltipText={hook.expectedReplyTooltip}
        onChange={hook.setFollowUpDuration}
      />

      <ActionCheckboxRow
        keepInAction={hook.keepInAction}
        sending={sending}
        checkingTone={checkingTone}
        onChange={event => hook.setKeepInAction(event.target.checked)}
      />

      <div>
        <TrackOpensCheckbox
          isTracking={props.isTrackingOpens}
          disabled={sending || checkingTone}
          onChange={props.onTrackOpensChange}
        />
      </div>

      <ButtonRow
        isDisabled={hook.isDisabled}
        sending={sending}
        checkingTone={checkingTone}
        showSchedulePopup={hook.showSchedulePopup}
        buttonText={hook.getButtonText()}
        toneCheckFailed={props.toneCheckFailed}
        onClose={onClose}
        onSend={hook.handleSend}
        onSendAnyway={hook.handleSendAnyway}
        onScheduleIconClick={hook.handleScheduleIconClick}
        onSelectSuggestion={hook.handleSelectSuggestion}
        onPickCustom={hook.handlePickCustom}
        onCloseSchedulePopup={() => hook.setShowSchedulePopup(false)}
      />
    </div>
  );
};
